var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirroringMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,6H7c-2.7568359,0-5,2.2431641-5,5v7h2v-7c0-1.6542969,1.3457031-3,3-3h34c1.6542969,0,3,1.3457031,3,3v24 c0,1.6542969-1.3457031,3-3,3H24v2h17c2.7568359,0,5-2.2431641,5-5V11C46,8.2431641,43.7568359,6,41,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,20v2c0.3555908,0,0.7028809,0.032959,1.0534058,0.0534058 c9.0831909,0.5297241,16.3634644,7.8099976,16.8931885,16.8931885C19.967041,39.2971191,20,39.6444092,20,40h2 C22,28.9716797,13.0283203,20,2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7301025,27.7301025C6.7314453,26.6294556,4.4384766,26,2,26v2c0.3555908,0,0.7055664,0.0228882,1.0533447,0.0533447 c5.7769775,0.5055542,10.3877563,5.116333,10.8933105,10.8933105C13.9771118,39.2944336,14,39.6444092,14,40h2 c0-2.4384766-0.6294556-4.7314453-1.7301025-6.7301025C12.9866943,30.9398193,11.0601807,29.0133057,8.7301025,27.7301025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,32v2c0.378418,0,0.7474365,0.0393066,1.1066284,0.1066284c2.421936,0.4539185,4.3328247,2.3648071,4.7867432,4.7867432 C7.9606934,39.2525635,8,39.621582,8,40h2C10,35.5888672,6.4111328,32,2,32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirroringMedium);
export default __webpack_public_path__ + "static/media/mirroring--medium.7b8e0f890ea06669825a39f4a5531c13.svg";
export { ForwardRef as ReactComponent };